import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainPosPanelComponent } from './main-pos-panel.component';
import { MapComponent } from './map/map.component';
import { FiltersComponent } from './filters/filters.component';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { TableComponent } from './table/table.component';

import { UtilityBarComponent } from './utility-bar/utility-bar.component';

import { FormsModule } from '@angular/forms';

import {
  NgbCollapseModule,
  NgbPaginationModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from '../app-routing.module';
import { FiltersComponent2 } from './filters/filters.component2';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  declarations: [
    MainPosPanelComponent,
    MapComponent,
    FiltersComponent,
    FiltersComponent2,
    TableComponent,
    UtilityBarComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    NgbCollapseModule,
    NgbPaginationModule,
    AppRoutingModule,
    DirectivesModule,
  ],
  exports: [MainPosPanelComponent],
})
export class MainPosPanelModule {}
